<template>
<columns class="items" :is-multiline="true">
    <column v-for="(skill, index) in skills" size="is-one-quarter" :key="index">
      <skill-item :skill="skill" :key="index" />
    </column>
    <column v-if="noSkills && editable">
      <skill-item v-on:add="addClicked" />
    </column>
</columns>
</template>

<script>
import Columns from '@/components/general/columns'
import Column from '@/components/general/column'
import SkillItem from '@/components/profile/skills/skill-item'

export default {
  components: { Columns, Column, SkillItem },
  props: {
    skills: {
      type: Array,
      default: () => []
    },
    editable: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    addClicked () {
      this.$emit('add')
    }
  },
  computed: {
    noSkills () {
      return !this.skills || this.skills.length === 0
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/skills/skills-list.vue